import { render } from "./BtnContent.vue?vue&type=template&id=bbe45568&scoped=true"
import script from "./BtnContent.vue?vue&type=script&lang=js"
export * from "./BtnContent.vue?vue&type=script&lang=js"

import "./BtnContent.vue?vue&type=style&index=0&id=bbe45568&scoped=true&lang=scss"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbe45568"]])

export default __exports__